module.exports = __webpack_public_path__ + "img/overdue.0d702050.png";